import React, { ReactElement, useState } from 'react';
import { SortDirection } from '../../models/sortDirection';
import SortIndicator from '../SortIndicator';
import './JobAudioFileList.scss';

export default function JobAudioFileList<TFile>(props: Props<TFile>) {
	const [sort, setSort] = useState<SortDirection>('asc');
	
	return (
		<React.Fragment>
			<div className="boxed-list__container boxed-list__container_with-header">
				<div className="boxed-list__header">
					<div className="flex flex-align-center full-height">
						<h5 className="flex-item-static cursor-pointer" onClick={toggleSort}>{props.header}</h5>
						<div className="flex-item-static">
							<div className="job-audio-file-list__sort-indicator">
								<SortIndicator sortClicked={toggleSort} sortDirection={sort} />
							</div>
						</div>
					</div>
				</div>

				<div className="boxed-list__item-container">
					{getSortedFiles().map((f, i) => props.children(f, i))}

					{!props.files.length &&
						<div className="boxed-list__item boxed-item__item_empty">No files</div>
					}
				</div>
			</div>
		</React.Fragment>
	);
	
	function getSortedFiles(): TFile[] {
		if (!sort)
			return props.files;
		
		return [...props.files].sort((f1, f2) => {
			const f1Name = props.getFilename(f1),
				f2Name = props.getFilename(f2);
			
			return sort === 'asc'
				? f1Name.localeCompare(f2Name)
				: f2Name.localeCompare(f1Name);
		});
	}
	
	function toggleSort() {
		setSort(prev => {
			return prev === 'asc'
				? 'desc'
				: 'asc';
		})
	}
}

interface Props<TFile> {
	header: string;
    files: TFile[];
    getFilename: (file: TFile) => string;
    children: (file: TFile, index: number) => ReactElement;
}
